import {
  CallChaining,
  FormFieldWidget,
  ModelFieldType,
  SPI,
  SubmitValue,
  ViewType,
  Widget
} from '@kunlun/dependencies';
import AreaSelect from './AreaSelect.vue';
import { CascaderProps } from 'ant-design-vue';
import { addressFileURL } from '../../../../utils/config';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: ModelFieldType.ManyToMany,
    widget: 'AreaSelect',
    multi: true
  })
)
export class FormM2mMultiAreaSelectFieldWidget extends FormFieldWidget {
  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;

  @Widget.Reactive()
  private areaList: string[][] = [];

  @Widget.Reactive()
  private areaOptions: CascaderProps['options'] = [];

  private areaObj: any = {};

  public initialize(props) {
    super.initialize(props);
    this.setComponent(AreaSelect);
    return this;
  }

  protected mounted() {
    super.mounted();
    if (this.mountedCallChaining) {
      this.mountedCallChaining.hook(this.path, async () => {
        await this.mountedProcess();
      });
    } else {
      this.mountedProcess();
    }
  }

  public async mountedProcess() {
    const res = await this.getRegionList();
    // 下钻，镇/乡/街道 不需要
    res.children.forEach((i) => {
      i?.children?.forEach((j) => {
        j?.children?.forEach((k) => {
          k.children = [];
        });
      });
    });
    this.areaOptions = [res];
    this.parseCascaderValue([res], this.areaObj);
    // this.setValue([{ code: '141124#khz' }]);

    ((this.value as any[]) || []).forEach((i) => {
      const codes = this.areaObj[i.code]?.allCode?.split(',') ?? '';
      this.areaList.push(codes);
    });
  }

  private parseCascaderValue(data: any[], obj) {
    data?.forEach((i) => {
      obj[i.code] = {
        ...i,
        allCode: obj[i.pCode]?.allCode ? obj[i.pCode].allCode + `,${i.code}` : i.code
      };
      this.parseCascaderValue(i?.children ?? [], obj);
    });
  }

  async submit(submitValue: SubmitValue) {
    return super.submit(submitValue);
  }

  private async getRegionList() {
    const res = await fetch(addressFileURL, { method: 'GET' });
    const data = await res.text();
    let str = data.replace('regionTreeResolve(', '').replace(/\)/g, '');
    return JSON.parse(str)[0];
  }

  @Widget.Method()
  private onChange(value: any[]) {
    this.areaList = value;
    const withName = this.model.model === 'libra.inventory.DistributorFulfillmentRegionWarehouse';
    this.setValue(
        value.map((item) => {
          const code = item[item.length - 1];
          return withName ? { code, name: this.areaObj[code]?.name } : { code };
        })
    );
  }
}
